export default {
  meta: {
    title: '数据迁移',
    url: '/system/migration' // 埋点用，记录所属模块
  },
};
